import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PenLine, Users, ArrowRight, Plus } from "lucide-react";
import api from "@/lib/api";
import { PageHero, Loading, Empty } from "@/components/common";

const STATUS_LABELS = {
  publicada: "Recolectando firmas", meta_alcanzada: "Meta alcanzada", entregada: "Entregada",
  recibida: "Recibida", esperando_respuesta: "Esperando respuesta", contestada: "Contestada",
  accion_tomada: "Acción tomada", cerrada: "Cerrada",
};

export default function Petitions() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/petitions").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <div data-testid="petitions-page">
      <PageHero label="2Voto Peticiones" title="Firma. Exige. Da seguimiento."
        subtitle="Convierte el descontento en una solicitud verificable, organizada y dirigida a quien tiene la autoridad para actuar. Tu identidad puede protegerse; tu firma cuenta." />
      <div className="max-w-5xl mx-auto px-6 py-12">
        <div className="flex justify-between items-center mb-8">
          <h2 className="font-heading font-black text-2xl text-slate-900">Peticiones activas</h2>
          <Link to="/peticiones/crear" data-testid="create-petition-link"
            className="inline-flex items-center gap-2 bg-slate-900 text-white text-sm font-semibold px-4 py-2.5 rounded-full hover:bg-slate-800 transition-colors">
            <Plus className="w-4 h-4" /> Crear petición
          </Link>
        </div>
        {items === null ? <Loading /> : items.length === 0 ? <Empty label="No hay peticiones publicadas todavía." /> : (
          <div className="space-y-5">
            {items.map((p) => {
              const pct = Math.min(100, Math.round((p.signatures.verified / p.goal) * 100));
              return (
                <Link key={p.id} to={`/peticiones/${p.id}`} data-testid={`petition-card-${p.id}`}
                  className="block bg-white rounded-xl border border-slate-200 p-6 hover:shadow-md hover:-translate-y-1 transition-all duration-200">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="inline-block px-3 py-1 rounded-full text-xs font-semibold bg-cyan-100 text-cyan-800">{STATUS_LABELS[p.status] || p.status}</span>
                    <span className="text-xs text-slate-400">Dirigida a: {p.addressed_to}</span>
                  </div>
                  <h3 className="font-heading font-bold text-xl text-slate-900 mb-2">{p.title}</h3>
                  <p className="text-sm text-slate-500 mb-4">Acción solicitada: <strong className="text-slate-700">{p.action_requested}</strong></p>
                  <div className="h-2.5 bg-slate-100 rounded-full overflow-hidden mb-2">
                    <div className="h-full bg-cyan-500 rounded-full" style={{ width: `${pct}%` }} />
                  </div>
                  <div className="flex items-center justify-between text-sm">
                    <span className="inline-flex items-center gap-1.5 text-slate-600 font-semibold"><Users className="w-4 h-4" /> {p.signatures.verified.toLocaleString("es-PR")} firmas verificadas</span>
                    <span className="inline-flex items-center gap-1 text-cyan-600 font-semibold">Firmar petición <PenLine className="w-4 h-4" /></span>
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
